<template>
    <div class="un-auth-wrappers">
        <div :class="{'closed': menuClosed}">
            <span v-a11y-action aria-label="Share" @click="toggleShareMenu" class="openarrow"><i aria-hidden="true" class="fa fa-2x fa-chevron-left"></i></span>
            <span v-a11y-action aria-label="Share" @click="toggleShareMenu" class="closearrow"><i aria-hidden="true" class="fa fa-2x fa-chevron-right"></i></span>
            <social-sharing network-tag="button" v-bind:url="videoURL" v-bind:quote = "metaTag_fb_title" v-bind:description = "metaTag_fb_title" v-bind:title = "metaTag_fb_title"  inline-template>
                <div  class="unauth-share-options">
                    <network network="facebook" class="holder"><span class="sr-only">Share via facebook</span>
                        <i aria-hidden="true" class="fa fa-2x fa-facebook cursor"></i>
                    </network>
                    <network network="twitter" class="holder"><span class="sr-only">Share via twitter</span>
                        <i aria-hidden="true" class="fa fa-2x fa-twitter cursor"></i>
                    </network>
                    <network network="linkedin" class="holder"><span class="sr-only">Share via linkedin</span>
                        <i aria-hidden="true" class="fa fa-2x fa-linkedin cursor"></i>
                    </network>
                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                        <i aria-hidden="true" class="fa fa-2x fa-envelope cursor"></i>
                    </network>
                </div>
            </social-sharing>
            <div class="slider responsive-slick-slider-top topcarosal" v-if="heroImage1 && !showCorporateLiveStreaming()">
                    <div class="slide-player">
                        <img class="jw-img" :src="heroImage1" alt="TOP IMAGE 1"/>
                        <!--<div class="content cursor text-left" @click="openModal(mindbodyVideo, 'Mind-Body Videos')">-->
                            <!--<i class="fa fa-play-circle-o"></i> {{mindbodyVideo.title}}-->
                        <!--</div>-->
                        <!--<h1>Hundreds of bite-sized expert videos. Learn-->
                            <!--and grow in just a few minutes every day.</h1>-->
                        <h1  v-html="dynamic_para_1"></h1>
                        <div class="buttonholderbanner" v-if="!isNativeApp">
                            <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}" v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
                                <button  v-if="!getCorporateGiftingCode" class="home-pink-button" @click="openTone4GoodLink()">Find Out More</button>
                            <div  class="clearfix"></div>
                            <i aria-hidden="true" v-if="showGiftingLinks" class="fa fa-gift"></i> <span v-a11y-action v-if="showGiftingLinks" @click="$router.push('/gifts')"><strong>GIVE THE GIFT OF TONE</strong></span>
                        </div>
                    </div>
                    <div class="slide-player">
                        <img class="jw-img" :src="heroImage2" alt="TOP IMAGE 2"/>
                        <!--<div class="content cursor text-left" @click="openModal(mindbodyVideo, 'Mind-Body Videos')">-->
                        <!--<i class="fa fa-play-circle-o"></i> {{mindbodyVideo.title}}-->
                        <!--</div>-->
                        <!--<h1>Get expert advice for your-->
                        <!--personal and professional life.</h1>-->
                        <h1  v-html="dynamic_para_2"></h1>
                        <div class="buttonholderbanner" v-if="!isNativeApp">
                            <button  v-if="!getCorporateGiftingCode" class="home-pink-button" @click="openTone4GoodLink()">Find Out More</button>
                            <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}"  v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
                            <div class="clearfix"></div>
                            <i aria-hidden="true" v-if="showGiftingLinks" class="fa fa-gift"></i> <span v-a11y-action v-if="showGiftingLinks" @click="$router.push('/gifts')"><strong>GIVE THE GIFT OF TONE</strong></span>
                        </div>
                    </div>
                    <div class="slide-player">
                        <img class="jw-img" :src="heroImage3" alt="TOP IMAGE 3"/>
                        <!--<div class="content cursor text-left" @click="openModal(mindbodyVideo, 'Mind-Body Videos')">-->
                        <!--<i class="fa fa-play-circle-o"></i> {{mindbodyVideo.title}}-->
                        <!--</div>-->
                        <!--<h1>Knowledge is power.<br>-->
                        <!--If you can dream it you can do it.</h1>-->
                        <h1  v-html="dynamic_para_3"></h1>
                        <div class="buttonholderbanner" v-if="!isNativeApp">
                            <button v-if="!getCorporateGiftingCode" class="home-pink-button" @click="openTone4GoodLink()">Find Out More</button>
                            <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}" v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
                            <div class="clearfix"></div>
                            <i aria-hidden="true" v-if="showGiftingLinks" class="fa fa-gift"></i> <span v-a11y-action v-if="showGiftingLinks" @click="$router.push('/gifts')"><strong>GIVE THE GIFT OF TONE</strong></span>
                        </div>
                    </div>
            </div>
            <div v-else>
                <div class="col-sm-offset-2 col-sm-8 livestreaming">
                    <div class="embed-responsive embed-responsive-16by9">
                <iframe title="TONE video player" :src="liveEventURL" width="100%" height="350px"  class="embed-responsive-item" frameborder="0" scrolling="auto" allowfullscreen ></iframe>
                   </div>
                    <h2  v-html="dynamic_para_12"></h2>
                    <h4  v-html="dynamic_para_13"></h4>
                    <!--<h2>TONE Live is streaming now!</h2>-->
                    <!--<h4>Sign in or become a member to participate</h4>-->
            </div>
            </div>
<div class="clearfix"></div><!--end of slider -->
            <section class="videoSections">
                <div class="container-fluid">

                            <div class="tabs-content">
                                <div class="tabs hide-mobile">
                                    <ul>
                                        <li @click.prevent="$router.push('/content/work')" class="videoList"><a :href="'/content/work'">WORK</a></li>
                                        <li @click.prevent="$router.push('/content/life')"  class="videoList"><a :href="'/content/life'">LIFE</a></li>
                                        <li @click.prevent="$router.push('/content/mindbody')"  class="videoList"><a :href="'/content/mindbody'">MINDBODY</a></li>
                                        <li @click.prevent="$router.push('/content/money')" class="videoList"><a :href="'/content/money'">MONEY</a></li>
                                    </ul>
                                </div>
                                <h2 class="text-center"  v-html="dynamic_para_4"></h2>
                                <!--<h2 class="text-center">Access to a growing library of short-form-->
                                    <!--videos, with topics customized for you.</h2>-->
                                <div class="text-center">
                                    <select class="show-mobile routeselect" v-model = "selectedRoute" :style="{'background-color': getCorpHeaderColor + ' !important'}">
                                        <option name ='workOption' value="work" selected>WORK</option>
                                        <option name ='lifeOption'  value="life">LIFE</option>
                                        <option name ='mindbodyOption'  value="mindbody">MINDBODY</option>
                                        <option name = 'moneyOption'  value="money">MONEY</option>
                                    </select>
                                </div>
                                <div class="slider responsive-slick-slider  hide-mobile">
                                <div class="tabContent" id="tabs-1">
                                    <div class="row video-row">
                                        <div class="col-xs-6 col-sm-6 col-md-3 slide-player"
                                             v-for = "work in workVideos">
                                            <a :href="'/contentvideos/play/' + work.mediaid + '/' + work.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <img class="jw-img" :src="work.image"  alt="WORK SECTION" :title="work.title" />
                                                <p class="cursor video-title">{{work.title}}</p></a>
                                            <social-sharing network-tag="button"  v-bind:url = "returnShareURL(work.mediaid)" v-bind:media= "returnShareURL(work.mediaid)" v-bind:quote = "work.title" v-bind:description = "work.Description" v-bind:title = "work.title" inline-template>
                                                <div>
                                                    <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                        <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                    </network>
                                                    <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                        <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                    </network>
                                                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                        <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                    </network>
                                                </div>
                                            </social-sharing>
                                        </div>
                                    </div>
                                </div>
                                <div class="tabContent" id="tabs-2">
                                    <div class="row video-row">
                                        <div class="col-xs-6 col-sm-6 col-md-3 slide-player"
                                             v-for = "life in lifeVideos">
                                            <a :href="'/contentvideos/play/' + life.mediaid + '/' + life.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <img class="jw-img" :src="life.image"  alt="LIFE SECTION" :title="life.title" />
                                                <p class="cursor video-title">{{life.title}}</p></a>
                                            <social-sharing network-tag="button"  v-bind:url = "returnShareURL(life.mediaid)" v-bind:media= "returnShareURL(life.mediaid)" v-bind:quote = "life.title" v-bind:description = "life.Description" v-bind:title = "life.title" inline-template>
                                                <div>
                                                    <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                        <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                    </network>
                                                    <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                        <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                    </network>
                                                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                        <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                    </network>
                                                </div>
                                            </social-sharing>
                                        </div>
                                    </div>
                                </div>
                            <div class="tabContent" id="tabs-3">
                                <div class="row video-row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 slide-player"
                                         v-for = "mb in mindbodyVideos">
                                        <a :href="'/contentvideos/play/' + mb.mediaid + '/' + mb.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="mb.image" alt="MINDBODY SECTION" :title="mb.title"/>
                                            <p class="cursor video-title">{{mb.title}}</p></a>
                                        <social-sharing network-tag="button"  v-bind:url = "returnShareURL(mb.mediaid)" v-bind:media= "returnShareURL(mb.mediaid)" v-bind:quote = "mb.title" v-bind:description = "mb.Description" v-bind:title = "mb.title" inline-template>
                                            <div>
                                                <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                    <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                </network>
                                                <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                    <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                </network>
                                                <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                    <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                </network>
                                            </div>
                                        </social-sharing>
                                    </div>
                                </div>
                            </div>
                            <div class="tabContent" id="tabs-4">
                                <div class="row video-row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 slide-player"
                                         v-for = "money in moneyVideos">
                                        <a :href="'/contentvideos/play/' + money.mediaid + '/' + money.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="money.image"  alt="MONEY SECTION" :title="money.title" />
                                        <p class="cursor video-title" >{{money.title}}</p></a>
                                        <social-sharing network-tag="button"  v-bind:url = "returnShareURL(money.mediaid)" v-bind:media= "returnShareURL(money.mediaid)" v-bind:quote = "money.title" v-bind:description = "money.Description" v-bind:title = "money.title" inline-template>
                                            <div>
                                                <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                    <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                </network>
                                                <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                    <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                </network>
                                                <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                    <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                </network>
                                            </div>
                                        </social-sharing>
                                    </div>
                                </div>
                            </div>
                                </div>
                                    <div class="row mobilevideotabs show-mobile">
                                        <div class="col-xs-6 smedia" v-for = "work in workVideos" v-if="selectedRoute === 'work'">
                                            <img v-a11y-action :aria-label="work.title" class="jw-img" :src="work.image" @click="openModal(work)" alt="WORK SECTION" :title="work.title"/>
                                            <p v-a11y-action class="cursor video-title" @click="openModal(work)">{{work.title}}</p>
                                            <social-sharing network-tag="button"  v-bind:url = "returnShareURL(work.mediaid)" v-bind:media= "returnShareURL(work.mediaid)" v-bind:quote = "work.title" v-bind:description = "work.Description" v-bind:title = "work.title" inline-template>
                                                <div>
                                                    <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                        <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                    </network>
                                                    <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                        <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                    </network>
                                                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                        <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                    </network>
                                                </div>
                                            </social-sharing>

                                        </div>
                                        <div class="col-xs-6" v-for = "life in lifeVideos" v-if="selectedRoute === 'life'">

                                                <img v-a11y-action :aria-label="life.title" class="jw-img" :src="life.image" @click="openModal(life)" alt="LIFE SECTION" :title="life.title" />
                                                <p v-a11y-action class="cursor video-title" @click="openModal(life)">{{life.title}}</p>
                                                <social-sharing network-tag="button"  v-bind:url = "returnShareURL(life.mediaid)" v-bind:media= "returnShareURL(life.mediaid)" v-bind:quote = "life.title" v-bind:description = "life.Description" v-bind:title = "life.title" inline-template>
                                                    <div>
                                                        <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                            <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                        </network>
                                                        <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                            <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                        </network>
                                                        <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                            <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                        </network>
                                                    </div>
                                                </social-sharing>

                                        </div>
                                        <div class="col-xs-6" v-for = "mb in mindbodyVideos" v-if="selectedRoute === 'mindbody'">

                                            <img v-a11y-action :aria-label="mb.title" class="jw-img" :src="mb.image" @click="openModal(mb)" alt="MINDBODY SECTION" :title="mb.title"/>
                                            <p v-a11y-action class="cursor video-title" @click="openModal(mb)">{{mb.title}}</p>
                                            <social-sharing network-tag="button"  v-bind:url = "returnShareURL(mb.mediaid)" v-bind:media= "returnShareURL(mb.mediaid)" v-bind:quote = "mb.title" v-bind:description = "mb.Description" v-bind:title = "mb.title" inline-template>
                                                <div>
                                                    <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                        <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                    </network>
                                                    <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                        <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                    </network>
                                                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                        <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                    </network>
                                                </div>
                                            </social-sharing>

                                        </div>
                                        <div class="col-xs-6" v-for = "money in moneyVideos" v-if="selectedRoute === 'money'">

                                            <img v-a11y-action :aria-label="money.title" class="jw-img" :src="money.image" @click="openModal(money)" alt="MONEY SECTION" :title="money.title" />
                                            <p v-a11y-action class="cursor video-title" @click="openModal(money)">{{money.title}}</p>
                                            <social-sharing network-tag="button"  v-bind:url = "returnShareURL(money.mediaid)" v-bind:media= "returnShareURL(money.mediaid)" v-bind:quote = "money.title" v-bind:description = "money.Description" v-bind:title = "money.title" inline-template>
                                                <div>
                                                    <network network="facebook"><span class="sr-only">Share via facebook</span>
                                                        <i aria-hidden="true" class="fa fa-facebook cursor"></i>
                                                    </network>
                                                    <network network="twitter"><span class="sr-only">Share via twitter</span>
                                                        <i aria-hidden="true" class="fa fa-twitter cursor"></i>
                                                    </network>
                                                    <network network="email" class="holder"><span class="sr-only">Share via email</span>
                                                        <i aria-hidden="true" class="fa fa-envelope cursor"></i>
                                                    </network>
                                                </div>
                                            </social-sharing>

                                        </div>
                                    </div>
                        </div>

                    <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}"  v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
<!--                    <button v-if="!getCorporateGiftingCode && !isNativeApp" class="home-pink-button" @click="$router.push('/b2b')">Find Out More</button>-->
                </div>
            </section>
            <section class="extertcontainer" v-if="getAllExperts">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-2 col-xs-6" v-for="expert in getAllExperts" v-if="expert.unauth_title && expert.small_image_bw">
                            <a :href="'/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" v-bind:style="{ color: getCorpHeaderColor + ' !important'}">
                            <img :src="expert.small_image_bw" :alt="expert.unauth_title" :title="expert.unauth_title"/>
                            {{expert.unauth_title}}
                             </a>
                        </div>
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/CaryCarbonaro.png" />-->
                            <!--The Money Queen-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/Christine-Li.jpg" />-->
                            <!--The Procrastination Coach-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/Jen-Lung.jpg" />-->
                            <!--Physical Therapist-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/Joelle.jpg" />-->
                            <!--Leadership Coach-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/LizaPitsirilos.png" />-->
                            <!--Stress Reliever-->
                        <!--</div>-->
                        <!--<div class="clearfix"></div>-->
                        <!--&lt;!&ndash;<div class="col-sm-12 hide-mobile">&ndash;&gt;-->
                            <!--&lt;!&ndash;<h2  v-html="dynamic_para_5"></h2>&ndash;&gt;-->
                            <!--&lt;!&ndash;&lt;!&ndash;<h2>Access a large network of top notch specialists and coaches who give you the guidance you need to reach your potential in your career and personal life.</h2>&ndash;&gt;&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                        <!--<div class="clearfix"></div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/maria.jpg" />-->
                            <!--Cultural Consultant-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/Michelle-Dawson.jpg" />-->
                            <!--Organizational Strategist-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/NancyRothstein.jpg" />-->
                            <!--The Sleep Ambassador-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/RamaniDurvasula.png" />-->
                            <!--Relationship Realist-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/RobinFisherRoffer.png" />-->
                            <!--Fearless Career Builder-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/SilberDe-profile.jpg" />-->
                            <!--Life Crisis Rebuilder-->
                        <!--</div>-->
                        <!--<div class="clearfix"></div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/Sonya-Barnes.jpg" />-->
                            <!--Personal Brand Expert-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/SwatiDesai.png" />-->
                            <!--Meditation Maven-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/traci-fields.jpg" />-->
                            <!--Diet Scientist-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/TracyAlloway.png" />-->
                            <!--Brain Trainer-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/ValGrubb.png" />-->
                            <!--Workplace Coach-->
                        <!--</div>-->
                        <!--<div class="col-sm-2 col-xs-6">-->
                            <!--<img src="../assets/vesna-gray.png" />-->
                            <!--Life Stage Health Coach-->
                        <!--</div>-->
                        <div class="col-sm-12"  v-bind:style="{ color: getCorpHeadingColor + ' !important'}" >
                            <h2 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}"  v-html="dynamic_para_5"></h2>
                            <!--<h2>Access a large network of top notch specialists and coaches who give you the guidance you need to reach your potential in your career and personal life.</h2>-->
                        </div>
                    </div>
                <div class="clearfix"></div>
                    <button class="home-pink-button" @click="$router.push('/experts')" v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}">
                        Meet our Experts
                    </button>
                </div>

            </section>
            <div class="clearfix"></div><!--end of slider -->
            <div class="clearfix"></div>

            <div v-if="getServicePodcast">
                <section class="radiosection"  v-bind:style="{ backgroundColor: podcastBgColor}">
                    <!-- h2 class="mb-5">THIS IS BUZZSPROUT 3 FRAMES</h2 -->
                    <h2 class="text-center"  v-bind:style="{color: '#ffffff', fontWeight: 'bold', 'font-size': '2em'}" v-html="podcastHeadingLine1"></h2>
                    <h3 class="text-center"  v-bind:style="{color: '#ffffff', fontWeight: 'bold', 'font-size': '1.75em'}" v-html="podcastHeadingLine2"></h3>
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-4" v-for="pod in getServicePodcast">
                                <iframe title="TONE video player" :src="pod.podcastUrl" loading= "lazy" width="95%" height="200" frameborder="0" scrolling="no" ></iframe>
                                <h4>{{pod.artist}} : {{pod.title}}</h4>
                                <p style="word-wrap: break-word">{{pod.description}}</p><br/>
                                <a :href="pod.readMoreUrl" target="_blank"><h4 v-bind:style="{color: '#000000'}">Read More</h4></a>
                            </div>

                        </div>
                    </div>
                </section>
            </div>

            <div class="container logoslider" v-if="corpLogos">
                <h2 v-if="dynamic_logosection_header" class="pinkh2" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}"><strong>{{dynamic_logosection_header}}</strong></h2>
                <br>
                <br>
                <div class="slider responsive-slick-corplogos" v-if="corpLogos">
                <!--<div v-for="member in staffMembers">-->
                    <div class="slide-player" v-for="logo in corpLogos">
                    <a :href="logo.linkDestination" target="_blank"><img :src="logo.logoUrl" :alt="logo.siteNameText" :title="logo.siteNameText"/></a>
                    <h4 v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}"><a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" :href="logo.linkDestination" target="_blank">{{logo.siteNameText}}</a></h4>
                    <!--<p>loren ipum lorem ipsum</p>-->
                    <!--<h4 class="text-center">{{member.memberFirstName}}<br /><small>{{member.position}}</small></h4>-->
                    <!--<p>{{member.biography}}</p>-->
                    </div>
                </div>
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/AnjaliHeadshot_rev.png"/>-->
                <!--<h4 class="text-center">Anjali Walter<br /><small>Head of Operations</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/val03.jpg"/>-->
                <!--<h4 class="text-center">Valerie J. Green<br /><small>Marketing & Brand Strategy Consultant</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Mike-Sorrentino-Producer.png"/>-->
                <!--<h4 class="text-center">Mike Sorrentino<br /><small>Producer</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--&lt;!&ndash;<div>&ndash;&gt;-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Elli-Zaverdas-Marketing-&-Sales-Director.png"/>-->
                <!--<h4 class="text-center">Elli Zaverdas<br /><small>Marketing & Sales Director</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Paula-Doyle-VP-of-Development-and-Community.png"/>-->
                <!--<h4 class="text-center">Paula Doyle<br /><small>VP of Development and Community</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Jonathan-Disegi-Brand-Consultant.png"/>-->
                <!--<h4 class="text-center">Jonathan Disegi<br /><small>Brand Consultant</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png"/>-->
                <!--<h4 class="text-center">Pippa Schwarzkopf<br /><small>Editor</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Dominique-Rollins-Editor.png"/>-->
                <!--<h4 class="text-center">Dominique<br /><small>Editor</small></h4>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="slide-player">-->
                <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Shiloh-Accuosti-Marketing-Assistant.png"/>-->
                <!--<h4 class="text-center">Shiloh Accuosti<br /><small>Marketing Assistant</small></h4>-->
                <!--</div>-->
                <!--</div>-->
            </div>
            <div class="clearfix"></div>
            <!-- section class="applicationdownload"><img class="showmobile" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png" alt="DOWNLOAD MOBILE APP" title="Download Mobile App" -->
            <section class="applicationdownload"><img class="showmobile" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-rebrand.png" alt="DOWNLOAD MOBILE APP" title="Download Mobile App">
                <h2><b>Get TONE on your Phone with the TONE app</b></h2>
                <a target="_blank" href="https://apps.apple.com/us/app/tone-networks-advice-on-demand/id1444962883?ls=1"><img class="appbtn" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-apple.png" alt="DOWNLOAD APPLE APP" title="Download App on IOS"></a>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.tonenetworks.toneapp"><img class="appbtn" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-android.png" alt="DOWNLOAD ANDROID APP" title="Download App on Android"></a>
            </section>
            <div class="clearfix"></div>

            <section class="testimonialsection" v-if="getAllTestimonials">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-6">
                            <h1>
                                “{{getAllTestimonials[0].quote}}”
                                <div class="author">--{{getAllTestimonials[0].author}}, {{getAllTestimonials[0].location}}</div>
                            </h1>
                        </div>
                        <div class="col-sm-6">
                            <h3>
                                “{{getAllTestimonials[1].quote}}”
                                <div class="author">--{{getAllTestimonials[1].author}}, {{getAllTestimonials[1].location}}</div>
                            </h3>
                        </div>
                        <div class="clearfix"></div>
                        <div class="col-sm-12" v-if="dynamic_testimonial_heading"><h2>{{dynamic_testimonial_heading}}</h2></div>
                        <div class="col-sm-6">
                            <h2>
                                “{{getAllTestimonials[2].quote}}”
                                <div class="author">--{{getAllTestimonials[2].author}}, {{getAllTestimonials[2].location}}</div>
                            </h2>
                        </div>
                        <div class="col-sm-6">
                            <h4>
                                “{{getAllTestimonials[3].quote}}”
                                <div class="author">--{{getAllTestimonials[3].author}}, {{getAllTestimonials[3].location}}</div>
                            </h4>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}"  v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
<!--                    <button v-if="!getCorporateGiftingCode && !isNativeApp" class="home-pink-button" @click="$router.push('/b2b')">Find Out More</button>-->
                    <!--<button class="home-pink-button" @click="$router.push('/signup')">-->
                       <!--Join Now-->
                    <!--</button>-->
                </div>

            </section>
            <img class="fullscreenimg" src="../assets/happy.jpg" alt="TONE EVENTS SECTION"/>
            <section class="eventssections text-center">

                <div class="container">
                    <!--<h2>-->
                        <!--Join the conversation with peers and professionals-->
                        <!--at TONE Talks and Live Streaming Events.-->
                    <!--</h2>-->
                    <h2  v-html="dynamic_para_6"></h2>
                    <div class="clearfix"></div>
                    <div class="row">
                        <div class="col-sm-4">
                            <span v-if="event1Dest && event1Dest.indexOf('/') > -1">
                                <span v-if="event1Dest.indexOf('http') > -1">
                                     <a :href="event1Dest" target="_blank" rel="opener"><img :src="event1Image" alt="TONE TALK EVENT"/></a>
                                <a :href="event1Dest" target="_blank" rel="opener"><h4  v-html="dynamic_para_7"></h4></a>
                                </span>
                                <span v-else>
                                     <a :href="event1Dest"><img :src="event1Image" alt="TONE TALK EVENT"/></a>
                                <a :href="event1Dest"><h4  v-html="dynamic_para_7"></h4></a>
                                </span>
                            </span>
                            <span v-else>
                                 <img :src="event1Image" alt="TONE TALK EVENT"/>
                            <h4  v-html="dynamic_para_7"></h4>
                            </span>
                        </div>
                        <div class="col-sm-4">
                            <span v-if="event2Dest">
                                 <span v-if="event2Dest.indexOf('http') > -1">
                                        <a :href="event2Dest" target="_blank" rel="opener"><img :src="event2Image" alt="TONE LIVE EVENT" /></a>
                                <a :href="event2Dest" target="_blank" rel="opener"><h4  v-html="dynamic_para_8"></h4></a>
                                 </span>
                                  <span v-else>
                                      <a :href="event2Dest"><img :src="event2Image" alt="TONE LIVE EVENT" /></a>
                                <a :href="event2Dest"><h4  v-html="dynamic_para_8"></h4></a>
                                  </span>
                            </span>
                            <span v-else>
                             <img :src="event2Image" alt="TONE LIVE EVENT" />
                            <h4  v-html="dynamic_para_8"></h4>
                            </span>
                        </div>
                        <div class="col-sm-4">
                            <span v-if="event3Dest">
                                 <span v-if="event3Dest.indexOf('http') > -1">
                                      <a :href="event3Dest" target="_blank" rel="opener"><img :src="event3Image" alt="ASK QUESTION" /></a>
                                <a :href="event3Dest" target="_blank" rel="opener"><h4  v-html="dynamic_para_9"></h4></a>
                                 </span>
                                <span v-else>
                                     <a :href="event3Dest"><img :src="event3Image" alt="ASK QUESTION" /></a>
                                <a :href="event3Dest"><h4  v-html="dynamic_para_9" alt="ASK QUESTION"></h4></a>
                                </span>
                            </span>
                            <span v-else>
                                 <img :src="event3Image" alt="ASK QUESTION" />
                            <h4  v-html="dynamic_para_9"></h4>
                            </span>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <button  v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}" v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
<!--                    <button v-if="!getCorporateGiftingCode && !isNativeApp" class="home-pink-button" @click="$router.push('/b2b')">Find Out More</button>-->
                    <!--<button class="home-pink-button" @click="$router.push('/signup')">-->
                        <!--Join Now-->
                    <!--</button>-->
                </div>

            </section>
            <div class="clearfix"></div>
<!--            <section class="charitycontainer">-->
<!--                <img src="../assets/womanonstairs-m.png" class="show-mobile" alt="TONE CHARITY"/>-->
<!--                <div class="container-fluid">-->
<!--                    <div class="row" style="width: 100%;">-->
<!--                        <div class="col-sm-6">-->
<!--                            <div class="centerpadding">-->
<!--                            &lt;!&ndash;<i class="nav-icon giving-icon"></i>&ndash;&gt;-->
<!--                            <img src="../assets/heart-icon-white.png" class="white-img" alt="TONE CHARITY">-->
<!--                            &lt;!&ndash;<i class="fa fa-bookmark-o"></i>&ndash;&gt;-->
<!--&lt;!&ndash;<h2>Give back to others&ndash;&gt;-->
<!--    &lt;!&ndash;through Clicks for Good</h2>&ndash;&gt;-->
<!--                            &lt;!&ndash;<p>The more you use TONE the more we give&ndash;&gt;-->
<!--                                &lt;!&ndash;to charities around the world. We make it&ndash;&gt;-->
<!--                                &lt;!&ndash;easy to give back to others.</p>&ndash;&gt;-->
<!--                            <h2  v-html="dynamic_para_10"></h2>-->
<!--                            <p  v-html="dynamic_para_11"></p>-->
<!--                            <div class="clearfix"></div>-->
<!--                                <div v-if="charities" v-for="charity in charities">-->
<!--                                    <a class="yellowbtn" :href="charity.website" target="_blank">{{charity.name.toString().toUpperCase()}}</a>-->
<!--                                    <div class="clearfix"></div>-->
<!--                                    <br>-->
<!--                                </div>-->
<!--                            &lt;!&ndash;<a class="yellowbtn" href="https://www.concernusa.org/" target="_blank">CONCERN WORLDWIDE</a>&ndash;&gt;-->
<!--                            &lt;!&ndash;<div class="clearfix"></div>&ndash;&gt;-->
<!--                            &lt;!&ndash;<br>&ndash;&gt;-->
<!--                            &lt;!&ndash;<a class="yellowbtn" href="https://www.NoKidHungry.org" target="_blank">SHARE OUR STRENGTH</a>&ndash;&gt;-->
<!--                        </div></div>-->
<!--                        &lt;!&ndash;<div class="col-sm-6">&ndash;&gt;-->
<!--                           &lt;!&ndash;</div>&ndash;&gt;-->
<!--                    </div>-->
<!--                    <button v-bind:style="{ backgroundColor: getCorpButtonColor}" v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>-->
<!--&lt;!&ndash;                    <button v-if="!getCorporateGiftingCode && !isNativeApp" class="home-pink-button" @click="$router.push('/b2b')">Find Out More</button>&ndash;&gt;-->
<!--                </div>-->
<!--            </section>-->
            <div class="clearfix"></div>
            <section class="aboutussection">
                <div class="container">
                    <div class="row">
                        <h2>About Us</h2>
                        <div class="col-sm-offset-1 col-sm-10" style="position:relative;">
                            <div class="" v-if="mainVideoPlay">
                                <jwplayer id="introVideo" :data="mainVideoPlay">Loading the player...</jwplayer>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}"  v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
<!--                    <button v-if="!getCorporateGiftingCode && !isNativeApp" class="home-pink-button" @click="$router.push('/b2b')">Find Out More</button>-->
                    <!-- Promo Video section (if exists) >-->
                    <!-- ADVISORY BOARD STARTS HERE -->
                    <div v-if="getAdvisoryBoard">
                        <section class="text-left advisory" >
                            <h2 v-bind:style="{fontWeight: 'bold', 'font-size': '2em'}">ADVISORY BOARD</h2>
                            <div class="row">
                                <div class="mb-3 col-sm-12" v-for="member in getAdvisoryBoard">
                                    <span v-bind:style="{color:'#f0617d', fontWeight: 'bold', 'font-size': '1.2em'}">{{member.key}}</span>
                                    <span v-bind:style="{textAlign: 'left', fontWeight: 'bold', 'font-size': '1.1em'}">{{member.value}}</span>
                                </div>
                            </div>
                        </section>
                    </div>
<!--
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-4" v-for="pod in getAdvisoryBoard">
                                <iframe :src="pod.podcastUrl" loading= "lazy" width="95%" height="200" frameborder="0" scrolling="no" ></iframe>
                                <h4>{{pod.artist}} : {{pod.title}}</h4>
                                <p style="word-wrap: break-word">{{pod.description}}</p><br/>
                                <a :href="pod.readMoreUrl" target="_blank"><h4 v-bind:style="{color: '#000000'}">Read More</h4></a>
                            </div>

                        </div>
                    </div>
 -->
                    <div class="clearfix"></div>
                    <!-- ADVISORY BOARD ENDS HERE -->

                    <div class="row" v-if="dynamic_aboutus_video2_code && this.dynamic_aboutus_video2_code.length > 3 && (dynamic_aboutus_video2_code !== ' ' || dynamic_aboutus_video2_code !== '')">
                        <h2 v-if="dynamic_aboutus_video2_title && (dynamic_aboutus_video2_title !== ' ' || dynamic_aboutus_video2_title !== '')">{{dynamic_aboutus_video2_title}}</h2>
                        <div class="col-sm-offset-1 col-sm-10" style="position:relative;">
                            <div class="" v-if="unauthPromoVideo">
                                <jwplayer id="unauthpromovideo" :data="unauthPromoVideo">Loading the player...</jwplayer>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor}"  v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo" @click="redeemGiftcode('popup')" class="home-pink-button">{{getCorporateGiftInfo.button_label_01}}</button>
<!--                        <button v-if="!getCorporateGiftingCode && !isNativeApp" class="home-pink-button" @click="$router.push('/b2b')">Find Out More</button>-->
                    </div>
                </div>
            </section>
            <!--<div class="topbanner-fixedheight">-->
<!--<div class="container">-->
    <!--<div class="row">-->
        <!--<div class="col-sm-offset-3 col-sm-6" style="position:relative;">-->
            <!--<div class="" v-if="mainVideoPlay">-->
                <!--<jwplayer id="introVideo" :data="mainVideoPlay">Loading the player...</jwplayer>-->
            <!--</div>-->
            <!--<div v-else>-->
                <!--<iframe :src="liveEventURL" width="100%" height="312px" style="max-height: 51vw;" frameborder="0" scrolling="auto" allowfullscreen ></iframe>-->
            <!--</div>-->
            <!--<div class="welcome-text">Welcome to Tone</div>-->
        <!--</div>-->
    <!--</div>-->
<!--</div>-->

            <!--</div>-->
            <!--<section class="greysection">-->
                <!--<div class="clearfix gap"></div>-->
                <!--<div class="text-center">-->

                    <!--<button v-if="!getCorporateGiftingCode" @click="redirectSignupFromPopUp()" type="button" class="btn btn-success btn-lg">Start Your Free Trial</button>-->
                    <!--<button v-if="getCorporateGiftingCode && getCorporateClient" @click="redeemGiftcode('popup')" type="button" class="btn btn-success btn-lg">{{getCorporateClient.button_label_01}}</button>-->
                <!--</div>-->
                <!--<div class="clearfix gap"></div>-->

                <!--<div class="container">-->
                    <!--<div class="row">-->
                        <!--<div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">-->
                            <!--<div class="clearfix"></div>-->
                            <!--<h3 v-if="dynamic_para_1"><strong> <p v-html="dynamic_para_1">-->
                                        <!--</p></strong>-->
                            <!--</h3>-->
                            <!--<p class="sub-heading"  v-if="dynamic_para_2" v-html="dynamic_para_2">-->
                              <!--</p><p class="sub-heading" v-if="dynamic_para_3" v-html="dynamic_para_3">-->
                        <!--</p><p class="sub-heading"  v-if="dynamic_para_4" v-html="dynamic_para_4">-->
                            <!--</p>-->
                            <!--<button v-if="!getCorporateGiftingCode" @click="redirectSignupFromPopUp()" type="button" class="btn btn-success btn-lg">Start Your Free Trial</button>-->
                            <!--<button v-if="getCorporateGiftingCode && getCorporateClient" @click="redeemGiftcode('popup')" type="button" class="btn btn-success btn-lg">{{getCorporateClient.button_label_01}}</button>-->
                            <!--<div class="clearfix gap"></div>-->
                            <!--<div class="entryholder">-->
                                <!--<div class="row">-->
                                    <!--<div class="col-sm-7 videoholder" id="work_scroll">-->

                                            <!--<div class="left-box-content">-->
                                                        <!--<div class="slider responsive-slick-slider">-->
                                                            <!--<div v-for="work in workVideos">-->
                                                                <!--<div class="slide-player">-->
                                                                    <!--<img class="jw-img" :src="work.image" @click="openModal(work, 'Work Videos')"/>-->
                                                                    <!--<div class="content cursor text-left" @click="openModal(work, 'Work Videos')">-->
                                                                        <!--<i class="fa fa-play-circle-o"></i> {{work.title}}-->
                                                                    <!--</div>-->
                                                                <!--</div>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                            <!--</div>-->

                                    <!--</div>-->
                                    <!--<div class="col-sm-4 text-holder">-->
                                        <!--<div class="right-box-content">-->
                                            <!--<div class="text-left">-->
                                                <!--<h3 class="heading">-->
                                                    <!--<span>Work</span>-->
                                                    <!--<i class="nav-icon career-pink-icon"></i>-->

                                                <!--</h3>-->
                                                <!--<p  v-if="dynamic_work_desc" v-html="dynamic_work_desc">-->
                                                    <!--&lt;!&ndash;Expert career coaching from reading a room and public speaking to climbing the corporate ladder, let our videos work for you.&ndash;&gt;-->
                                                <!--</p>-->

                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->


                            <!--<div class="entryholder">-->
                                <!--<div class="row">-->
                                    <!--<div class="col-sm-7 videoholder" id="life_scroll">-->

                                        <!--<div class="left-box-content">-->
                                            <!--<div class="slider responsive-slick-slider">-->
                                                <!--<div  v-for="life in lifeVideos">-->
                                                    <!--<div class="slide-player">-->
                                                        <!--<img class="jw-img" :src="life.image" @click="openModal(life, 'Life Videos')"/>-->
                                                        <!--<div class="content cursor text-left" @click="openModal(life, 'Life Videos')">-->
                                                            <!--<i class="fa fa-play-circle-o"></i> {{life.title}}-->
                                                        <!--</div>-->
                                                    <!--</div>-->
                                                <!--</div>-->
                                            <!--</div>-->
                                        <!--</div>-->

                                    <!--</div>-->
                                    <!--<div class="col-sm-4 text-holder">-->
                                        <!--<div class="right-box-content">-->
                                            <!--<div class="text-left">-->
                                                <!--<h3 class="heading">-->
                                                    <!--<span>Life</span>-->
                                                    <!--<i class="nav-icon inspiration-pink-icon"></i>-->

                                                <!--</h3>-->
                                                <!--<p v-if="dynamic_life_desc" v-html="dynamic_life_desc">-->
                                                    <!--&lt;!&ndash;From stress busting and simplification to time management, our expert videos help bring balance to life's juggling act. &ndash;&gt;-->
                                                <!--</p>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->


                            <!--<div class="entryholder">-->
                                <!--<div class="row">-->
                                    <!--<div class="col-sm-7 videoholder" id="mind_body_scroll">-->

                                        <!--<div class="left-box-content">-->
                                            <!--<div class="slider responsive-slick-slider">-->
                                                <!--<div v-for="mindbodyVideo in mindbodyVideos">-->
                                                    <!--<div class="slide-player">-->
                                                        <!--<img class="jw-img" :src="mindbodyVideo.image" @click="openModal(mindbodyVideo, 'Mind-Body Videos')"/>-->
                                                        <!--<div class="content cursor text-left" @click="openModal(mindbodyVideo, 'Mind-Body Videos')">-->
                                                            <!--<i class="fa fa-play-circle-o"></i> {{mindbodyVideo.title}}-->
                                                        <!--</div>-->
                                                    <!--</div>-->
                                                <!--</div>-->
                                            <!--</div>-->
                                        <!--</div>-->

                                    <!--</div>-->
                                    <!--<div class="col-sm-4 text-holder">-->
                                        <!--<div class="right-box-content">-->
                                            <!--<div class="text-left">-->
                                                <!--<h3 class="heading">-->
                                                    <!--<span>Mind Body</span>-->
                                                    <!--<i class="nav-icon mind-body-pink-icon"></i>-->

                                                <!--</h3>-->
                                                <!--<p v-if="dynamic_mindbody_desc " v-html="dynamic_mindbody_desc ">-->
                                                    <!--&lt;!&ndash;Squeeze in some ‘me’ time: Be more mindful, relieve stress, get fit and eat healthier right now. &ndash;&gt;-->
                                                <!--</p>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->



                            <!--<div class="entryholder">-->
                                <!--<div class="row">-->
                                    <!--<div class="col-sm-7 videoholder" id="money_scroll">-->

                                        <!--<div class="left-box-content">-->
                                            <!--<div class="slider responsive-slick-slider">-->
                                                <!--<div  v-for="money in moneyVideos">-->
                                                    <!--<div class="slide-player">-->
                                                        <!--<img class="jw-img" :src="money.image" @click="openModal(money, 'Money Videos')"/>-->
                                                        <!--<div class="content cursor text-left" @click="openModal(money), 'Money Videos'">-->
                                                            <!--<i class="fa fa-play-circle-o"></i> {{money.title}}-->
                                                        <!--</div>-->
                                                    <!--</div>-->
                                                <!--</div>-->
                                            <!--</div>-->
                                        <!--</div>-->

                                    <!--</div>-->
                                    <!--<div class="col-sm-4 text-holder">-->
                                        <!--<div class="right-box-content">-->
                                            <!--<div class="text-left">-->
                                                <!--<h3 class="heading">-->
                                                    <!--<span>Money</span>-->
                                                    <!--<i class="nav-icon money-pink-icon"></i>-->

                                                <!--</h3>-->
                                                <!--<p v-if="dynamic_money_desc" v-html="dynamic_money_desc" >-->
                                                    <!--&lt;!&ndash;Investing, saving, and financial independence  expert videos will help you make the most of your money.&ndash;&gt;-->
                                                <!--</p>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->




                            <!--<div class="entryholder">-->
                                <!--<div class="row">-->
                                    <!--<div class="col-sm-7 videoholder" id="events_scroll">-->

                                        <!--<div class="left-box-content">-->
                                            <!--<div class="slider responsive-slick-slider">-->
                                                <!--<div v-if="getCommunityLearnMoreVideo">-->
                                                    <!--&lt;!&ndash;<div class="slide-player" v-for="communityVideo in getCommunityVideo">&ndash;&gt;-->
                                                    <!--<a href="'#/newevents" target="_blank">-->
                                                    <!--<img class="jw-img" :src="getCommunityLearnMoreVideo.image" @click=""/>-->
                                                    <!--<div class="content cursor text-left" @click="">-->
                                                        <!--<i class="fa fa-play-circle-o"></i> {{getCommunityLearnMoreVideo.title}}-->
                                                    <!--</div>-->
                                                    <!--</a>-->
                                                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                                                <!--</div>-->
                                            <!--</div>-->
                                        <!--</div>-->

                                    <!--</div>-->
                                    <!--<div class="col-sm-4 text-holder">-->
                                        <!--<div class="right-box-content">-->
                                            <!--<div class="text-left">-->
                                                <!--<h3 class="heading">-->
                                                    <!--<a href="#/newevents" target="_blank">-->
                                                    <!--<span class="lastOne">Events</span>&nbsp;<i class="fa fa-calendar"></i>-->
                                                    <!--</a>-->
                                                <!--</h3>-->
                                                <!--&lt;!&ndash;<h3 v-else>&ndash;&gt;-->
                                                    <!--&lt;!&ndash;<span class="lastOne">Events</span>&nbsp;<i class="fa fa-calendar"></i>&ndash;&gt;-->
                                                <!--&lt;!&ndash;</h3>&ndash;&gt;-->
                                                <!--<p v-if="dynamic_event_desc" v-html="dynamic_event_desc">-->
                                                    <!--&lt;!&ndash;Join weekly chat groups on timely topics of importance to women, and attend and interact in live streaming events with prominent women leaders.&ndash;&gt;-->
                                                <!--</p>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->





                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->

                <!--<div class="clearfix gap"></div>-->
                <!--<div class="text-center">-->
                    <!--<button v-if="!getCorporateGiftingCode" @click="redirectSignupFromPopUp()" type="button" class="btn btn-success btn-lg">Start Your Free Trial</button>-->
                    <!--<button v-if="getCorporateGiftingCode && getCorporateClient" @click="redeemGiftcode('popup')" type="button" class="btn btn-success btn-lg">{{getCorporateClient.button_label_01}}</button>-->
                    <!--&lt;!&ndash;<button class="btn btn-success btn-lg">Start Your Free Trial</button>&ndash;&gt;-->
                <!--</div>-->
                <!--<div class="clearfix gap"></div>-->
                <!--<div class="clearfix gap"></div>-->
            <!--</section>-->
        </div>

        <modal v-if="showModal" effect="zoom" :value="showModal" @cancel="cancelModal('0')" width="400">
            <div slot="modal-header">
            </div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentPlayerID">Loading the player...</jwplayer>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
        <modal v-if="showWatchVideoModal" class="watchVideoModal" effect="zoom" :value="showWatchVideoModal" @cancel="cancelModal('1')">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action aria-label="Close" href="javascript:" @click="cancelModal('1')">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentPlayerID" id="unAuthPlayer">Loading the player...</jwplayer>
                <p>
                    {{currentVideoDesc}}
                </p>
                <button v-if="!getCorporateGiftingCode" @click="redirectSignupFromPopUp()" type="button" class="btn btn-success btn-lg" >Start Your Free Trial</button>
                <button v-if="getCorporateGiftingCode" @click="redeemGiftcode('popup')" type="button" class="btn btn-success btn-lg">Redeem Your Gift</button>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import modal from '@/accessibility/Modal'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import store from '../store'
    // import InfiniteSlideBar from 'vue-infinite-slide-bar'
//    import { dateHelpers } from '../helpers/dateHelpers.js'
    export default {
        name: 'UnAuth',
        components: {
            jwplayer,
            modal: modal,
            'jwplaylist': JwPlayList
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                menuClosed: true,
                corporateLiveStreamingFlag: false,
                currentPlayerID: null,
                showModal: false,
                showWatchVideoModal: false,
                workVideos: '',
                lifeVideos: '',
                mindbodyVideos: '',
                moneyVideos: '',
                charities: '',
                currentVideoDesc: '',
                planDescription: '',
                planId: '',
                defaultPlan: '',
                mainVideoPlay: '',
                unauthPromoVideo: '',
                liveEventVideo: '',
                corporateGiftCode: this.$route.params.giftCode ? this.$route.params.giftCode : '',
                liveEventURL: '',
                heroImageList: ['https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-2.jpg', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-3.jpg'],
//                heroImageList: ['https://s3.amazonaws.com/tone-assets/images/slide-1.jpg', 'https://s3.amazonaws.com/tone-assets/images/slide-2.jpg', 'https://s3.amazonaws.com/tone-assets/images/slide-3.jpg'],
                dynamic_para_1: '',
                dynamic_para_2: '',
                dynamic_para_3: '',
                dynamic_para_4: '',
                dynamic_para_5: '',
                dynamic_para_6: '',
                dynamic_para_7: '',
                dynamic_para_8: '',
                dynamic_para_9: '',
                dynamic_para_10: '',
                dynamic_para_11: '',
                dynamic_para_12: '',
                dynamic_para_13: '',
                dynamic_para_14: '',
                dynamic_work_desc: '',
                dynamic_life_desc: '',
                dynamic_mindbody_desc: '',
                dynamic_money_desc: '',
                dynamic_event_desc: '',
                dynamic_aboutus_video2_title: '',
                dynamic_aboutus_video2_code: '',
                dynamic_logosection_header: 'TONE has been featured in',
                dynamic_testimonial_heading: 'Our members and clients love us!',
                heroImage1: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg',
                heroImage2: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-2.jpg',
                heroImage3: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-3.jpg',
                event1Image: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/icon_chat.png',
                event1Dest: '',
                event2Image: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/icon_communication.png',
                event2Dest: '',
                event3Image: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/icon_heel.png',
                event3Dest: '',
                allUnauthVideos: null,
                videoURL: window.location.href,
                videoReference: '',
                selectedRoute: 'work',
                isNativeApp: false,
                isNativeAppNavigation: false,
//                corpLogos: ['https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/1_emiGsBgJu2KHWyjluhKXQw.png', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/download.png', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/oprah-magazine-1.png', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/Inc-Magazine-logo-300x300.png', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/Inc-Magazine-logo-300x300.png', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/Inc-Magazine-logo-300x300.png', 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/Inc-Magazine-logo-300x300.png'],
                corpLogos: null,
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: '',
                metaTag_pageTitle: 'Welcome to TONE Networks!',
                showGiftingLinks: false,
                appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation',
                podcastHeadingLine1: '',
                podcastHeadingLine2: '',
                podcastBgColor: '',
                tabs: {
                    work: true,
                    life: false,
                    mindbody: false,
                    money: false
                }
            }
        },
        methods: {
            openTone4GoodLink: function () {
                if (this.getFindOutMoreUrl) {
                    window.open(this.getFindOutMoreUrl, '_blank')
                }
            },
            openToneForGoodLink () {
                window.open('https://forgood.tonenetworks.com/?hs_preview=zMhyLpxA-30398892724', '_blank')
            },
            toggleShareMenu () {
                console.log('new toggle option', this.menuClosed)
                this.menuClosed = !this.menuClosed
            },
            changeRoute (option) {
                this.$router.push(`/content/${option}`)
            },
            returnShareURL (videoCode) {
                return `${this.videoURL}contentvideos/play/${videoCode}`
            },
            switchTab: function (id) {
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
            },
            create () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.each(function () {
                    // var length = $(this).children().length === 1
//                    console.info(length)
                    $(this).slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            setLogoCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-corplogos')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: false,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            createTopCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider-top')
                $slick.each(function () {
                    // var length = $(this).children().length === 1
//                    console.info(length)
                    $(this).slick({
                        dots: false,
                        useTransform: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 6000,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            destroy () {
                $(this.$el).find('.responsive-slick-slider').slick('unslick')
            },
            reSlick () {
                this.destroy()
                this.create()
            },
            redirectSignup (tag) {
                window.logEvents('Unauthenticated Page', 'click', tag)
                if (this.$route.params.planId) {
                    this.$router.push('/signup/' + this.$route.params.planId)
                } else {
                    this.$router.push('/signup/')
                }
            },
            redeemGiftcode (mode) {
                let self = this
                if (mode === 'popup') {
                    this.currentPlayerID = null
                    this.cancelModal('0')
                }
                setTimeout(function () {
                    console.log('inside UnAuth.vue -> ----------------------> typeof self.getCorporateClientId', typeof self.getCorporateClientId)
                    if (self.getCorporateClientId === '112' || self.getCorporateClientId === '197') {
                        self.$router.push(`/corporationgiftingcustom/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                    } else if (self.getCorporateClientId === '200') {
                        // self.$router.push('/horizonsso/sso1data')
                        self.$router.push('/horizonsso?no_assertion_found=true')
                    } else if (self.getCorporateClient.invitationCode === '2') {
                        self.$router.push(`/corporation/referral/buy/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                    } else {
                        self.$router.push(`/corporationgifting/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                    }
                }, 400)
            },
            redirectSignupFromPopUp () {
                window.logEvents('Unauthenticated Page', 'click', 'Signup from Video Popup')
                this.cancelModal('0')
                if (this.$route.params.planId) {
                    this.$router.push('/signup/' + this.$route.params.planId)
                } else {
                    this.$router.push('/signup/')
                }
            },
            redirectLogin (event) {
                this.$router.push('/login')
            },
            setPlayer (playerObject) {
                this.currentPlayerID = {video: playerObject.sources[1].file, title: playerObject.title, img: playerObject.image, playerID: new Date()}
                this.showModal = true
            },
            cancelModal (log) {
                if (log === '1') {
                    window.logEvents('Unauthenticated Page', 'click', 'Video Popup Closed')
                }
                var self = this
                var $ = window.jQuery
                this.currentPlayerID = null
                setTimeout(function () {
                    self.showModal = false
                    self.showWatchVideoModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 200)
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            openModal (mainVideoObj) {
                // window.logEvents('Unauthenticated Page' + ' - ' + tag, 'Play', 'Title - ' + mainVideoObj.title)
                this.$router.push(`/contentvideos/play/${mainVideoObj.mediaid}`)
            },
            showCorporateLiveStreaming () {
                let self = this
                if (self.$route.params.corporateId && self.$route.params.giftCode) { // URL has corporate parameters
                    if (self.liveEventURL && self.corporateLiveStreamingFlag) { // Check if there is livestreamign URL and streaming is enabled
                        return true
                    } else {
                        return false
                    }
                } else {
                    if (self.liveEventURL) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        },
        watch: {
            'getGiftingLinksFlag' (to, from) {
                let self = this
                if (self.getGiftingLinksFlag) {
                    self.showGiftingLinks = false
                } else {
                    self.showGiftingLinks = true
                }
            },
            'dynamic_aboutus_video2_code' (to, from) {
                let self = this
                if (self.dynamic_aboutus_video2_code && self.dynamic_aboutus_video2_code.length > 3 && (self.dynamic_aboutus_video2_code !== ' ' || self.dynamic_aboutus_video2_code !== '')) {
                    // Fetch the promo video section
                    self.$store.dispatch('GETPROMOVIDEOFORCODE', self.dynamic_aboutus_video2_code).then(() => {
                        if (self.getPromoVideo) {
                            let video = this.getPromoVideo
                            self.unauthPromoVideo = {
                                video: video[0].sources[video[0].sources.length - 1].file,
                                title: video[0].title,
                                img: video[0].image,
                                playerID: new Date(),
                                tracks: video[0].tracks,
                                Description: video[0].description,
                                mediaId: video[0].mediaid,
                                isMute: true,
                                showCaptions: true,
                                repeat: true,
                                autoStart: false
                            }
                            setTimeout(() => {
                                window.jwplayer().seek(1)
                                window.jwplayer().pause(true)
                            }, 500)
                        } else {
                            self.unauthPromoVideo = null
                        }
                    })
                }
            }
        },
        mounted: function () {
//            navigator.__defineGetter__('userAgent', function () {
//                return 'gonative'
//            })
            let self = this
            // Get Unauth Navigation bar
            console.log('HERE - before gonative check!!!')
            if (navigator.userAgent.indexOf('gonative') > -1) {
                this.isNativeApp = true
                this.isNativeAppNavigation = true
                // Get Unauth Navigation bar
                $.getJSON(`${self.appNavigationURL}/sidebar_unauth.json`, function (data) {
                    console.log('side navigation (unuath) returned', data)
                    var json = JSON.stringify(data)
                    window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json)
                }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })

                if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                    // Get Unauth Bottom bar - not for android
                    setTimeout(function () {
                        $.getJSON(`${self.appNavigationURL}/bottomNav_unauth.json`, function (data) {
                            console.log('bottom navigation (unauth) returned', data)
                            var json = JSON.stringify(data)
                            window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json)
                        }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                    }, 500)
                }
            }
            setTimeout(() => {
                this.createTopCarousal()
                this.setLogoCarousal()
            }, 1500)
            this.currentPlayerID = null
            this.$store.dispatch('GETDYNAMICCONTENTS', 1).then(() => {
                if (this.getAllSiteContents) {
                    // Load Meta Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    // Load Dynamic Contents
                    this.dynamic_para_1 = this.setDynamicSection(this.getAllSiteContents, 'TOP_CAROUSEL_HEADING_1')
                    this.dynamic_para_2 = this.setDynamicSection(this.getAllSiteContents, 'TOP_CAROUSEL_HEADING_2')
                    this.dynamic_para_3 = this.setDynamicSection(this.getAllSiteContents, 'TOP_CAROUSEL_HEADING_3')
                    this.dynamic_para_4 = this.setDynamicSection(this.getAllSiteContents, 'VIDEO_HEADING')
                    this.dynamic_para_5 = this.setDynamicSection(this.getAllSiteContents, 'EXPERT_HEADING')
                    this.dynamic_para_6 = this.setDynamicSection(this.getAllSiteContents, 'EVENT_HEADING')
                    this.dynamic_para_7 = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_1')
                    this.dynamic_para_8 = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_2')
                    this.dynamic_para_9 = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_3')
                    this.dynamic_para_10 = this.setDynamicSection(this.getAllSiteContents, 'CHARITY_HEADING_1')
                    this.dynamic_para_11 = this.setDynamicSection(this.getAllSiteContents, 'CHARITY_SUB_HEADING_2')
                    this.dynamic_para_12 = this.setDynamicSection(this.getAllSiteContents, 'LIVE_STREAMING_HEADING_1')
                    this.dynamic_para_13 = this.setDynamicSection(this.getAllSiteContents, 'LIVE_STREAMING_SUB_HEADING_1')
                    // New Changes
                    this.heroImage1 = this.setDynamicSection(this.getAllSiteContents, 'TOP_CAROUSEL_IMG_1')
                    this.heroImage2 = this.setDynamicSection(this.getAllSiteContents, 'TOP_CAROUSEL_IMG_2')
                    this.heroImage3 = this.setDynamicSection(this.getAllSiteContents, 'TOP_CAROUSEL_IMG_3')
                    this.event1Image = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_1_IMG')
                    this.event1Dest = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_1_URL')
                    this.event2Image = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_2_IMG')
                    this.event2Dest = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_2_URL')
                    this.event3Image = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_3_IMG')
                    this.event3Dest = this.setDynamicSection(this.getAllSiteContents, 'EVENT_SUB_HEADING_3_URL')
                    this.dynamic_logosection_header = this.setDynamicSection(this.getAllSiteContents, 'LOGO_SECTION_HEADING')
                    this.dynamic_aboutus_video2_title = this.setDynamicSection(this.getAllSiteContents, 'ABOUTUS_VIDEO2_TEXT')
                    this.dynamic_aboutus_video2_code = this.setDynamicSection(this.getAllSiteContents, 'ABOUTUS_VIDEO2_CODE')
                    this.dynamic_testimonial_heading = this.setDynamicSection(this.getAllSiteContents, 'TESTIMONIAL_HEADING')
                    // 08/15/2021
                    this.podcastHeadingLine1 = this.setDynamicSection(this.getAllSiteContents, 'PODCAST_HDG_1')
                    this.podcastHeadingLine2 = this.setDynamicSection(this.getAllSiteContents, 'PODCAST_HDG_2')
                    this.podcastBgColor = this.setDynamicSection(this.getAllSiteContents, 'PODCAST_BG_COLOR')
//                    console.log('get video code', this.dynamic_aboutus_video2_code)
                }
            })

            // self.$store.dispatch('GETEVENTSARCHIVEPLAYLIST_EVENTID2', 179).then(() => {
            self.$store.dispatch('GET_PODCAST_FOR_SERVICE', 'buzzsprout').then(() => {
                // if (this.getServicePodcast) {
                // }
            })
            self.$store.dispatch('GET_ADVISORY_BOARD', 'ADVISORY BOARD').then(() => {
            })

            // Check if parametrized
            if (this.$route.params.planId) {
                this.planId = this.$route.params.planId
                this.$store.dispatch('GETPLAN', this.planId).then(() => {
                    this.defaultPlan = this.getDefaultPlan
                    this.planDescription = 'Start Your ' + this.defaultPlan.type + ' Trial'
                    if (this.getDefaultPlan) {
                        this.$store.commit('setMarketingPlan', {planId: this.$route.params.planId})
                    } else {
                        this.$store.commit('setMarketingPlan', {planId: null})
                    }
                })
            } else if (this.$route.params.giftCode && this.$route.params.corporateId) {
                this.$store.commit('setCorporateGiftingCode', {giftCode: this.$route.params.giftCode})
                this.$store.commit('setCorporateClientId', {corporateClientId: this.$route.params.corporateId})
                this.$store.dispatch('GETCORPORATECLIENT', this.$route.params.corporateId).then(() => {
                    if (this.getCorporateClient) {
                        this.$store.dispatch('GETCORPORATECLIENT_GIFT_DETAILS', {giftCode: this.$route.params.giftCode, corporationId: this.$route.params.corporateId}).then(() => {
                            if (this.getCorporateGiftInfo) {
                                // console.log('current gift information', this.getCorporateGiftInfo)
                            } else {
                                // Gift wasn't found or was invalid code
                                this.$store.commit('setCorporateGiftingCode', {giftCode: null})
                                this.$store.commit('setCorporateClientId', {corporateClientId: null})
                                if (localStorage.getItem('corporateClientObject')) {
                                    localStorage.removeItem('corporateClientObject')
                                }
                                if (localStorage.getItem('corporateGiftInfoObject')) {
                                    localStorage.removeItem('corporateGiftInfoObject')
                                }
                                this.$store.commit('setCorporateClient', {client: null})
                                this.$store.commit('setCorporateGiftInfo', {gift: null})
                            }
                        })
                    }
                })
            } else {
                this.planDescription = 'Start Your 7-Day Free Trial'
                this.$store.commit('setMarketingPlan', {planId: 0})
                this.$store.commit('setCorporateGiftingCode', {giftCode: null})
                this.$store.commit('setCorporateClientId', {corporateClientId: null})
                this.$store.commit('setCorporateClient', {client: null})
                if (localStorage.getItem('corporateClientObject')) {
                    localStorage.removeItem('corporateClientObject')
                }
                this.$store.commit('setCorporateGiftInfo', {gift: null})
                if (localStorage.getItem('corporateGiftInfoObject')) {
                    localStorage.removeItem('corporateGiftInfoObject')
                }
            }
            this.$store.dispatch('GETAPPCONFIGRATION').then(() => {
                if (this.getLiveStreamingStatus === 1) {
                    this.liveEventURL = this.getLiveStreamingURL
                } else {
                    this.liveEventURL = null
                }
                if (this.getCorporateLiveStreamFlag === 1) {
                    this.corporateLiveStreamingFlag = true
                } else {
                    this.corporateLiveStreamingFlag = false
                }
            })
            this.$store.dispatch('GETTESTIMONIALS', 'UNAUTH').then(() => {
            })
            // Retreive Videos to be displayed
            this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(() => {
                if (this.getAboutUsVideo) {
                    this.mainVideoPlay = {
                        video: this.getAboutUsVideo.sources[this.getAboutUsVideo.sources.length - 1].file,
                        title: this.getAboutUsVideo.title,
                        img: this.getAboutUsVideo.image,
                        playerID: new Date(),
                        tracks: this.getAboutUsVideo.tracks,
                        isMute: true,
                        showCaptions: true,
                        repeat: true,
                        autoStart: false,
                        mediaId: this.getAboutUsVideo.mediaid
                    }
                    setTimeout(() => {
                        this.videoReference = window['currentVideoId']
                        window.jwplayer().seek(1)
                        window.jwplayer().pause(true)
                    }, 500)
                }
//                    this.liveEventVideo = {video: this.getMainVideo.sources[this.getMainVideo.sources.length - 1].file, title: this.getMainVideo.title, img: this.getMainVideo.image, playerID: new Date(), tracks: this.getMainVideo.tracks, isMute: true, showCaptions: true}
                this.workVideos = this.getWorkVideo
                this.mindbodyVideos = this.getMindbodyVideo
                this.lifeVideos = this.getLifeVideos
                this.moneyVideos = this.getMoneyVideo
                this.allUnauthVideos = this.getAllUnauthVideos.filter(x => {
                    return x.tags === 'work' || x.tags === 'life' || x.tags === 'mindbody' || x.tags === 'money'
                })
                setTimeout(() => {
                    this.create()
                }, 1000)
            })
            // Get Experts
            this.$store.dispatch('GETALLEXPERTS').then(() => {
            })
            // Retreive Charities
            this.$store.dispatch('GETALLCHARITIES').then(() => {
                this.charities = this.getAllCharities
            })
            // Retreive Company Logos
            this.$store.dispatch('GETCOMPANYLOGOS', 'UNAUTH').then(() => {
                this.corpLogos = this.getCompanyLogos
                if (this.corpLogos) {
                    setTimeout(() => {
                        this.setLogoCarousal()
                    }, 1000)
                }
            })
            if (sessionStorage.getItem('redirectPath')) {
                let redirectPath = sessionStorage.getItem('redirectPath')
                if (redirectPath.toLowerCase().indexOf('liveevent') >= 0 || redirectPath.toLowerCase().indexOf('talk') >= 0 || redirectPath.toLowerCase().indexOf('teaser') >= 0 || redirectPath.toLowerCase().indexOf('takeaway') >= 0 || redirectPath.toLowerCase().indexOf('playlist') >= 0 || redirectPath.toLowerCase().indexOf('trending') >= 0 || redirectPath.toLowerCase().indexOf('corporation/mycommunity') || redirectPath.toLowerCase().indexOf('becomemember') >= 0 || redirectPath.toLowerCase().indexOf('tonearchive') >= 0 || redirectPath.toLowerCase().indexOf('/events') >= 0) {
                    store.commit('setTriggerLogin', {loginStatus: true})
                }
            }
//            $(function () {
//                let count = 0
//                let wordsArray = ['time management', 'simplification', 'stress busting', 'being more productive', 'conscious eating', 'executive presence', 'goal setting', 'finding focus', 'avoiding burnout', 'reading a room', 'financial planning', 'boosting your memory', 'nailing nutrition', 'work-life balance', 'and much, much more!']
//                setInterval(function () {
//                    count++
//                    $('#keywords').fadeOut(800, function () {
//                        $(this).text(wordsArray[count % wordsArray.length]).fadeIn(800)
//                    })
//                }, 2000)
//            })
            this.$store.dispatch('CACHEPAGE', window.location.href)
            if (self.getGiftingLinksFlag) {
                self.showGiftingLinks = false
            } else {
                self.showGiftingLinks = true
            }
            if (this.user) {
                window.juapp('arb', '[userId]', '[auth]')
            } else {
                window.juapp('arb', '[userId]', '[unauth]')
            }
        },
        computed: {...mapGetters([
            'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'getMainVideo', 'error', 'getAllCharities',
            'getDefaultPlan', 'getWorkLearnMoreVideo', 'getLifeLearnMoreVideo', 'getMindbodyLearnMoreVideo', 'getMoneyLearnMoreVideo',
            'getCommunityLearnMoreVideo', 'getLiveEventVideo', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient',
            'getLiveStreamingStatus', 'getLiveStreamingURL', 'getAllSiteContents', 'getAllTestimonials', 'getAboutUsVideo', 'getAllUnauthVideos',
            'getAllExperts', 'getCorporateLiveStreamFlag', 'getPromoVideo', 'getCompanyLogos', 'getGiftingLinksFlag', 'getFindOutMoreUrl',
            'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo', 'getServicePodcast',
            'getAdvisoryBoard'
        ])
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .pinkh2{
        color: #f0617d;
        font-family: 'Zilla Slab', serif
    }
    .home-top-img img {
        max-width: 100%;
    }
    .home-top-img img {
        max-width: 100%;
    }

    .home-top-img {
        position: relative;
    }

    .layover {
        background: rgba(0,0,0,0.5);
        position: absolute;
        color: #fff;
        font-weight: bold;
        font-size: 18px;
        padding: 20px;
        left: 0px;
        right: 0px;
        top: 0;
        bottom: 0;
    }
    .layover span {
        position: absolute;
        top: 50%;
        letter-spacing: 5px;
        font-size: 26px;
        display: block;
        line-height: 1.3;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        right: 0;
        text-align: center;
    }
    .layover.default span {
        text-shadow: 0 3px 4px rgba(0,0,0,0.75);
    }
    .layover{
        transition: all 0.5s ease;
        opacity:0;
    }
    .home-top-img:hover .layover{
        opacity:1;
    }
    .gap{height: 30px;}
    .layover.default{
        opacity:1;
        background: transparent;
    }
    .home-top-img:hover .layover.default{
        opacity:0;
    }
    h1.main {
        font-size: 36px;
        color: #f0617d;
        font-family: sans-serif;
        margin: 0 0 20px;
    }
    @media(max-width:767px) {
        h3.heading
        > i > img {
            max-width: 46px;
        }
    }
    div#keywords {
        color:#f0617d;
        font-size:32px;
        padding:10px 0 0;
    }
    @media(max-width:1200px){
        .un-auth-wrappers .over-lay .main-heading h1 {
            padding: 0 !important;
        }
    }
    @media(max-width:767px){
        .gap-for-mobile.clearfix {
            height: 10px;
        }
        .un-auth-wrappers .blog-section p {
            margin: 10px 0 5px !important;
            line-height: 1.5;
        }
        div#giving_scroll
        .goods-section.clearfix
        .margin-bottom-40 h1{
            margin-top:0 !important;
        }

        .goods-section.clearfix {
            margin-top: -50px;
        }
        .layover.default span {
            display: block;
            border: 2px solid #fff;
            margin-left: 20px;
            margin-right: 20px;
        }

        .layover span {
            padding: 20px;
        }
        .row.padding30 {
            margin: 0 -30px;
        }

    }
    @media(min-width:768px){
        .row.padding30 {
            margin-left: 0;
            margin-right: 0;
        }

        .row.padding30 .col-sm-4 {
            padding: 0 30px;
        }
    }
    .sub-heading {
        letter-spacing: 2px;
        font-size: 19px;
        font-weight: 600;
        color:#000;
        margin: 0 0 30px;
    }
    h3{
        font-size:28px;
        color:#000;
        margin: 0 0 20px;
    }
    .welcome-text{
        font-size: 15px;
        letter-spacing: 1px;
        font-weight: 600;
    }

    .watchVideoModal .modal-dialog .modal-body button {
        color: #fff !important;
        background-color: #5cb85c !important;
        border-color: #4cae4c !important;
    }
    .watchVideoModal .modal-dialog .modal-body button:hover {
        color: #fff;
        background-color: #449d44;
        border-color: #398439;
    }
    section.extertcontainer img {
        max-width: 100%;
        border-radius: 50%;
        margin: 0 auto 10px;
    }
    section.extertcontainer h2{
        font-size:26px;
        color:#f0617d;
        margin:10px 20px 40px;
    }
    section.extertcontainer{
        padding:50px 0;
    }

    section.extertcontainer {
        font-size: 16px;
        color: #f0617d;
    }
    img.fullscreenimg {
        width: 100%;
    }

    section.eventssections {
        background: #f7a434;
        color: #fff;
        padding: 50px 20px 50px;
    }

    section.eventssections h2 {
        max-width: 850px;
        margin: 10px auto 20px;
        font-family: 'Zilla Slab', serif;
        font-size: 36px;
    }

    section.eventssections h4 {
        font-size: 20px;
        max-width: 300px;
        margin: 20px auto;
        font-weight:700;
    }
    section.eventssections img {
        max-width: 70px;
        margin: 30px auto 10px;
    }
    .livestreaming {
        font-family: 'Zilla Slab', serif;
        padding-top:40px;
    }
    section.charitycontainer img {
        max-width: 100%;
        margin: 0 auto 10px;
    }

    section.charitycontainer {
        background: url(../assets/womanonstairs.png);
        color: #fff;
        background-size: cover;
        background-position: center;
        padding-top:40px;
        padding-bottom: 10px;
    }
    @media(min-width:1440px){
        section.charitycontainer {
            background-position: center top;
            padding-top: 80px;
            padding-bottom: 20px;
        }
    }
    @media(min-width:1600px)
    {
        section.charitycontainer {
            background-image: url(../assets/womanonstairs-long.png);
            background-position: center top;
            background-size: cover;
            padding-top: 80px;
            padding-bottom: 50px;
        }
    }

    section.charitycontainer > .fa {
        font-size: 50px;
    }

    section.charitycontainer i.fa {
        font-size: 50px;
        margin-top: 50px;
    }
    img.white-img {
        -webkit-filter: brightness(1000%);
        filter: brightness(1000%);
    }
    section.charitycontainer p {
        font-size: 24px;
    }

    section.charitycontainer h2 {
        font-size: 42px;
        font-family: 'Zilla Slab', serif;
    }

    a.yellowbtn {
        background: #f7a434;
        font-size: 18px;
        background: #f7a434;
        font-size: 18px;
        margin: 4px;
        border: 0 none transparent;
        padding: 11px 22px;
        color: white;
        min-width: 250px !important;
        display: inline-block;
        margin: 0;
    }
    /*.tabContent:not(.current) {*/
        /*display: none;*/
    /*}*/
    .tabs ul li a {
        display: block;
        background: #ee637e;
        color: #fff;
        min-width: 216px;
        padding: 2px;
        font-family: 'Zilla Slab', serif;
        font-weight: 300;
        font-size: 25px;
    }

    .tabs ul li {
        display: inline-block;
        margin: 10px;
    }
    .tabs ul li:nth-of-type(2) a{
        background:#f7a434;
    }
    .tabs ul li:nth-of-type(3) a{
        background:#946084;
    }
    .tabs ul li:nth-of-type(4) a{
        background:#aec643;
    }
    .tabContent i.fa {
        font-size: 21px;
        color: #616161;
        margin:0 3px;
    }
    .tabContent i, .tabContent p {
        font-size: 18px;
        font-weight: 400;
        font-weight: 400;
        line-height: 1;
        text-transform: capitalize;
    }
    .tabContent i{
        margin:0 3px
    }
    section.extertcontainer .col-sm-2 {
        font-style:italic;
        line-height:1;
    }
    p.cursor.video-title{
        font-family: 'Zilla Slab', serif;
        margin: 7px 0 15px;
        font-weight: 500;
        text-align: center;
        text-transform: capitalize;
        font-size: 19px;
    }

    .tabs-content h2.text-center {
        font-size: 52px;
        max-width: 980px;
        margin: 30px auto;
        font-family: 'Zilla Slab', serif;
    }

    a {}

    .tabs ul li a {
        font-family: 'Zilla Slab', serif;
        font-weight: 100;
    }
    body .un-auth-wrappers .slider h1 {
        font-family: 'Zilla Slab', serif;
        font-size: 44px;
    }
    button.home-pink-button {
        font-size: 19px;
        font-family: 'Montserrat', sans-serif;
    }
    .buttonholderbanner i {
        font-size: 130%;
    }

    .buttonholderbanner > span {
        cursor: pointer;
        display:inline-block;
    }
    .row.video-row img.jw-img {
        border: 1px solid #666;
    }
    section.extertcontainer h2 {
        font-family: 'Zilla Slab', serif;
        font-size: 32px ;
    }
    .row.video-row i.fa {
        font-size: 18px;
    }

    body .un-auth-wrappers .slider h1 {
        font-family: 'Zilla Slab', serif;
        font-size: 44px;
    }

    button.home-pink-button {
        font-size: 19px;
    }

    .row.video-row img.jw-img {
        border: 1px solid #666;
    }

    .row.video-row
        img.jw-img {      border: 1px solid #666;  }


    section.extertcontainer h2 {
        font-family: 'Zilla Slab', serif;
        font-size: 28px !important;
        font-style:normal;
    }
    section.extertcontainer button{

        font-style:normal;
    }

    section.extertcontainer {
        font-family: 'Zilla Slab', serif;
    }

    .show-mobile {
        display: none;
    }
    @media(max-width:767px){
        section.extertcontainer .col-sm-2.col-xs-6 {
            min-height: 210px;
            min-height: 60vw;
        }

        section.extertcontainer h2 {
            font-size: 19px !important;
        }

        .tabs-content h2.text-center {
            font-size: 21px;
        }
        .show-mobile {
            display: block;
        }

        section.charitycontainer {
            padding-top: 0;
        }

        section.charitycontainer img.show-mobile {
            margin: 0 0 40px;
        }

        section.charitycontainer {
            background: #a36285;
        }

        section.charitycontainer .row {
            width: auto !important;
        }
        .row.mobilevideotabs.show-mobile > .col-xs-6 {
            padding: 0 0 20px;
            line-height: 1;
        }

        .row.mobilevideotabs.show-mobile >
        .col-xs-6:nth-of-type(odd) {
            clear: left;
        }

        .row.mobilevideotabs.show-mobile >
        .col-xs-6 p.cursor.video-title {
            margin: 7px 0 15px !important;
        }

    }
    section.aboutussection {
        padding-bottom: 10px;
    }

    section.eventssections.text-center {
        padding-bottom: 10px;
    }

    section.testimonialsection {
        padding-bottom: 10px;
    }

    section.extertcontainer {
        padding-bottom: 10px;
    }
    section.extertcontainer .col-sm-2 {
        padding-bottom: 20px;
    }
    section.videoSections button.home-pink-button {
        margin: 0;
    }
    section.videoSections button.home-pink-button {
        margin: 0;
    }

    .centerpadding {
        max-width: 550px;
        margin: auto;
    }

    .centerpadding h2 {
        margin-bottom: 20px;
    }

    .centerpadding p {
        margin-bottom: 20px;
    }
    @media(max-width:1024px){
        body .un-auth-wrappers .slider h1
        {
            margin:0;
            padding:0 30px;
        }
    }
    @media(max-width:992px) and (min-width:768px){
        body .un-auth-wrappers .slider h1
        {margin: 0 auto;font-size:40px !important;top:40px;transform: translateX(-50%) translateY(0%);padding:0 50px;}
    }
    @media(min-width:803px) and (max-width:1050px){
        .tabs.hide-mobile ul li a {
            width: 100%;
            padding: 0;
            min-width: 0;
        }
        .tabs.hide-mobile ul li {
            margin: 1%;
            width: 22%;
        }
        .tabs.hide-mobile ul {
            padding: 0;
        }
    }
    section.extertcontainer .col-sm-12 {
        clear:both;
    }
    section.applicationdownload {
        padding: 300px 20px 30px;
        /* background-image: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png); */
        background-image: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/app-image-resized-rebrand.png);
        background-size: cover;
        background-position: center;
        position: relative;
    }

    section.applicationdownload img.showmobile {
        display: none;
    }

    section.applicationdownload b {
        color: #fff;
    }

    section.applicationdownload:after {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.35);
    }

    section.applicationdownload>* {
        position: relative;
        z-index: 1;
    }

    section.applicationdownload h2 {
        font-family: Zilla Slab,serif;
        font-size: 45px!important;
        font-style: normal;
        margin: 0 0 140px;
    }


    section.applicationdownload .appbtn {
        max-width: 220px;
        margin: 0 25px;
    }
    @media(max-width:768px){
        section.applicationdownload .appbtn {
            max-width: 220px;
            margin: 0 10px;
        }
        section.applicationdownload img.showmobile {
            display: block;
            width: 100%;
        }

        section.applicationdownload {
            padding: 0 0 50px;
            background: #fff;
        }

        section.applicationdownload h2 {
            margin: 40px 0;
            color: #000;
            padding: 0 20px;
        }

        section.applicationdownload:after {
            display: none;
        }

        section.applicationdownload h2 b {
            color: #000;
            font-size: 34px!important;
        }
    }
    @media(min-width:768px){
        section.radiosection .row {display: flex;justify-content: center;}
    }
    /* .radiosection {padding:10px 20px;background:#eee;} */
    .radiosection {padding:10px 20px;}

    section.radiosection p {
        font-size: 18px;
    }

    section.radiosection h4 {
        font-weight: 700;
        font-size: 21px;
    }
    /* ADVISORY BOARD SECTION BELOW */
    section.text-left.advisory {
        max-width: 900px;
        padding: 0 40px 20px;
        border-top: 5px solid #faa51e;
        border-bottom: 5px solid #faa51e;
        margin: 60px auto;
        position: relative;
    }

    section.text-left.advisory:before {content: "";background-color: #bde8e1;width: 5px;top: 10px;bottom: 10px;left: 20px;display: block; position: absolute;}

    section.text-left.advisory .mb-3 {
        margin-bottom: 10px;
    }

</style>
<style>

    .smedia span {
        padding: 5px;
    }
    .unauth-header .notificationtext {
        font-family: 'Zilla Slab', serif;
    }
    .topbanner-fixedheight {
        background: #efefef;
    }

    .topbanner-fixedheight > div:not(.Welcome-text) {
        max-height: inherit;
    }

    .topbanner-fixedheight > div >div#introVideo {
        max-height: inherit;
    }
    .topbanner-fixedheight .jwplayer.jw-stretch-uniform video{object-fit:cover;}
    .welcome-text {
        font-size: 30px;
        text-align: center;
        color: #FFF;
        position: absolute;
        top: 5px;
        left: 30px;
        font-weight: bold;
    }

    section.greysection {
        background: #efefef;
    }

    .entryholder p {
        font-size: 17px;
        font-weight:500;
        color:#000;
    }

    .entryholder {
        margin-bottom: 50px;
    }

    .entryholder:nth-of-type(3) {
        border-bottom: 10px solid #966c91;
    }
    .entryholder:nth-of-type(4) {
        border-bottom: 10px solid #f9a827;
    }
    .entryholder:nth-of-type(5) {
        border-bottom: 10px solid #adc736;
    }
    .entryholder:nth-of-type(6) {
        border-bottom: 10px solid #57c1af;
    }


    .entryholder h3{
        color:#f0778f;
        font-size:30px;
        padding-right:10px;
    }
    body .un-auth-wrappers .slider  h1 {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateY(-50%) translateX(-50%);
        transform: translateY(-50%) translateX(-50%);
        color: #fff;
        font-size: 38px;
        width: 860px;
        max-width: 100%;
    }

    .buttonholderbanner {
        position: absolute;
        bottom: 30px;
        left: 0;
        right: 0;
        padding: 10px;
        color: #fff;
    }

    .buttonholderbanner .home-pink-button {
        background: #f0617d;
        border: 0;
        /*padding: 10px 70px;*/
        margin:0 0 10px;
    }
    body .un-auth-wrappers .slider .slick-next:before{
        content:">";
        color:#fff !important;
        font-size: 60px;
        font-weight:900 !important;
        text-shadow: 0px 2px 2px rgba(0,0,0,0.75);
    }
    body .un-auth-wrappers .slider .slick-prev:before{
        content:"<";
        color:#fff !important;
        font-size: 60px;
        font-weight: 900 !important;
        text-shadow: 0px 2px 2px rgba(0,0,0,0.75);
    }


    body .un-auth-wrappers .slick-prev {
        left: 50px;
    }

    body .un-auth-wrappers .slick-next {
        right: 50px;
    }
    html body .un-auth-wrappers .slide-player{
        margin:0;
        /*min-height: 275px;*/
    }
    .home-pink-button {
        background: #f0617d;
        border: 0;
        padding: 10px;
        color:#fff;
        margin: 30px auto;
        min-width: 220px;
        text-transform: uppercase;
    }
    section.testimonialsection {
        padding: 80px 20px 40px;
        background: #b3c94e;
        color:#fff;
        font-family: 'Zilla Slab', serif;
    }

    section.testimonialsection h3 {
        color: #fff;
        font-style: italic;
    }

    section.testimonialsection h2 {
        margin: 20px 20px 40px;
        font-size: 90px;
    }
    section.testimonialsection .col-sm-6 h1,
    section.testimonialsection .col-sm-6 h2,
    section.testimonialsection .col-sm-6 h3,
    section.testimonialsection .col-sm-6 h4 {
        margin: 0 0 20px;
        font-style:italic;
    }
    section.testimonialsection .col-sm-6 h1{
        font-size: 43px;
        font-weight:600;
    }
    section.testimonialsection .col-sm-6 h2{
        font-size:38px;
        font-weight:600;
    }
    section.testimonialsection .col-sm-6 h3{
        font-size:34px;
        font-weight:600;
    }
    section.testimonialsection .col-sm-6 h4{
        font-size:29px;
        font-weight:600;
    }
    section.testimonialsection .author {
        font-size: 18px;
        margin: 10px 0;
        font-style: normal;
        font-weight: 100;

    }
    section.aboutussection h2 {
        font-size: 42px;
        font-family: 'Zilla Slab', serif;
        margin: 30px 0;
    }

    body .un-auth-wrappers section.videoSections .tabs-content .slick-slider  .slick-slide{
        padding-left: 100px;
        padding-right: 80px;
    }

    body .un-auth-wrappers section.videoSections .tabs-content .slider .slick-prev:before {
        color:#000 !important;
        line-height: 0;
    }

    body .un-auth-wrappers section.videoSections .tabs-content .slider .slick-next:before {
        color:#000 !important;
        line-height: 0;
    }

    body .un-auth-wrappers section.videoSections .tabs-content .slider .slick-prev {
        left:40px
    }

    body .un-auth-wrappers section.videoSections .tabs-content .slider .slick-next {
        right:40px
    }
    .hide-mobile{
        display:block;
    }
    @media(min-width:992px){
        .col-xs-6.col-sm-6.col-md-3.slide-player:nth-of-type(4n + 5) {
            clear: left;
        }
    }
    @media(min-width:768px) and (max-width:991px){
        .col-xs-6.col-sm-6.col-md-3.slide-player:nth-of-type(odd) {
            clear: left;
        }
    }
    @media(max-width:767px){
        .slick-slider{
            margin-bottom:0;
        }
        .hide-mobile{
            display:none;
        }
        html body .un-auth-wrappers .slider h1 {
            font-size: 18px !important;
            padding: 20px;
            position:static;
            -webkit-transform: translateY(0%) translateX(0%);
            transform: translateY(0%) translateX(0%);
            color: #000;
        }

        .buttonholderbanner {
            position: static;
            bottom: 0;
            padding: 5px;
            color:#000;
        }
        body .unauth-header header .nav-container .mobile-loginLogoutholder{
            position:static;
        }
        .unauth-header header .nav-container .navbar-header a.navbar-toggle {
            padding: 10px;
            top: 5px;
            margin: 0;
            height: 10px;
            width: 10px;
        }

        body .unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {
            padding: 3px 10px;
            border: 0 none transparent;
            font-size: 18px;
            margin: 0;
        }
        .tabs > ul {
            margin: 0;
            padding: 0;
        }
        select.show-mobile.routeselect {
            margin: 0 auto 30px;
            background: #f0617d;
            color: #fff;
            border: 0 none transparent;
            text-align: center;
            outline: none 0 transparent;
            min-width: 200px;
            padding: 10px;
        }

        select.show-mobile.routeselect option {
            background: #fff;
            color: #343434;
            border-color: #f0617d;
            outline: none 0 transparent;
        }

        body .un-auth-wrappers .topcarosal button.slick-prev.slick-arrow ,
        body .un-auth-wrappers .topcarosal button.slick-next.slick-arrow {
            top: 25%;
        }
        body .un-auth-wrappers .topcarosal button.slick-prev.slick-arrow:before ,
        body .un-auth-wrappers .topcarosal button.slick-next.slick-arrow:before {
            color:#fff !important;
        }
        body .un-auth-wrappers .slider .slick-prev:before{
            color:#000 !important;
        }
        body .un-auth-wrappers .slider .slick-next:before{
            color:#000 !important;
        }
        body .un-auth-wrappers .slick-next {
            right: 10px !important;
        }

        body .un-auth-wrappers .slick-prev {
            left: 10px !important;
        }

        section.extertcontainer img {
            display: block;
        }

        section.testimonialsection h2 {
            font-size: 44px;
        }
    }
    @media(min-width:768px){
        section.extertcontainer .col-xs-6:nth-of-type(6n + 7) {
            clear: left;
        }
    }
    section.eventssections a {
        color: #fff;
    }
    section.eventssections h4 {
        color: #fff;
    }
</style>
<style>
    .entryholder ul.slick-dots {
        display: none !important;
    }
    .slick-prev.slick-disabled:before, .slick-next.slick-disabled:before{opacity:0;}
    .un-auth-wrappers .slick-next{
        right:0;
    }
    .un-auth-wrappers .slick-prev {
        left: -7px;
        z-index: 1;
    }
    .un-auth-wrappers .tabContent  .row.video-row i.fa {
        font-size: 20px ;
        color:#666;
        margin:0 3px;
    }
    .entryholder .content.cursor.text-left {
        display: none;
    }

    .entryholder .slick-slider {
        margin: 0;
    }

    .entryholder .slide-player {
        margin: 0;
    }

    .unauth-share-options {
        position: fixed;
        padding: 10px 0;
        z-index: 1;
        right: 0;
        top: 261px;
        width: 80px;
        background: rgba(255, 255, 255, 0.6)
    }

    .un-auth-wrappers {
        position: relative;
    }

    .unauth-share-options > span, .unauth-share-options > button {
        display: block;
        padding: 10px;
    }
    .closed span.closearrow {
        transform: translateX(100%);
    }
    .unauth-share-options {
        transition: all 1s ease;
    }

    .closed .unauth-share-options {
        transform: translateX(100%);
    }

    span.openarrow {
        position: fixed;
        right: 0;
        width: 80px;
        transition: all 1s ease;
        transform: translateX(100%);
        background: rgba(255, 255, 255, 0.6);
        display: block;
        padding: 10px;
        z-index:200;
        top: 212px;
    }

    span.closearrow {
        position: fixed;
        right: 0;
        width: 80px;
        transition: all 1s ease;
        background: rgba(255, 255, 255, 0.6);
        display: block;
        padding: 10px;
        z-index: 100;
        top: 212px;
    }

    .closed > span.openarrow {
        transform: translateX(0);
    }





    @media(min-width:768px) and (max-width:1199px){
        span.closearrow ,
        span.openarrow {
            top: 197px !important;
        }

        .unauth-share-options {
            top: 246px;
        }
    }
    @media (max-width:767px){
        span.closearrow ,
        span.openarrow {
            top: 73px !important;
        }

        .unauth-share-options {
            top: 122px;
        }
        span.closearrow ,
        span.openarrow {
            background: rgba(255, 255, 255, 0.75);
        }
        .unauth-share-options {
            background: rgba(255, 255, 255, 0.75)
        }
    }
    @media (min-width:1800px) {
        span.closearrow,
        span.openarrow {
            top: 373px !important;
        }

        .unauth-share-options {
            top: 422px;
        }
    }

    .logoslider .slick-slide img {
        width: 130px;
    }

    body .un-auth-wrappers .logoslider .slick-next , body .un-auth-wrappers .logoslider .slick-prev {
        top: 60px;
        background: transparent;
        height: auto;
        width: auto;
        line-height: 1;
        height: 50px;
        width: 50px;
        color: #fff;
        right: -50px !important;
        text-align: center;
    }

    body .un-auth-wrappers .logoslider .slick-next:before , body .un-auth-wrappers .logoslider .slick-prev:before {
        font-size: 30px;
        display: block;
        font-weight: 900;
        text-shadow: 0 0 0 transparent;
        line-height: 47px !important;
        color: #fff !important;
        background: #A9A9A9 !important;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        text-align: center;
    }
    body .un-auth-wrappers .logoslider .slick-prev {
        left: -50px !important;
        text-align: center;
    }

    .container.logoslider {
        padding: 0 50px;
    }
    html body .un-auth-wrappers .logoslider .slide-player {
        text-align: center;
    }

    html body .un-auth-wrappers .logoslider .slide-player img {
        margin: 0 auto 20px;
    }
    html body .un-auth-wrappers .logoslider .slide-player h4,
    html body .un-auth-wrappers .logoslider .slide-player p{
        max-width:200px;
        display :block;
        margin:0 auto;
    }
    @media(max-width:767px){
        .container.logoslider {
            padding: 0 70px;
        }
    }
    .logoslider ul.slick-dots {
        display: none !important;
    }
    .container.logoslider {
        padding-bottom: 50px !important;
    }

</style>



// WEBPACK FOOTER //
// UnAuth.vue?1ef1025d